webpackJsonp([1376664881398],{

/***/ 393:
/***/ (function(module, exports) {

	module.exports = {"data":{"site":{"siteMetadata":{"title":"Blog by Rahul Patil","subtitle":"Cloud, Bots, AI and more..","author":{"name":"Rahul","twitter":"#"},"disqusShortname":"","url":"https://lumen.netlify.com"}},"markdownRemark":{"id":"/opt/build/repo/src/pages/articles/2018-10-24--Hello-Gatsby/index.md absPath of file >>> MarkdownRemark","html":"<h2>Hello gatsby</h2>\n<p>Testing gatsby</p>","fields":{"tagSlugs":["/tags/typefaces/"]},"frontmatter":{"title":"Hello Gatsby","tags":["Typefaces"],"date":"2018-10-24T12:40:32.169Z","description":"Test"}}},"pathContext":{"slug":"/posts/hello-gatsby"}}

/***/ })

});


// WEBPACK FOOTER //
// path---posts-hello-gatsby-18ff41f7e3e2ac440450.js